import { Box, Text } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import React, { useState, useEffect } from 'react';
import { useEditAdministratorContext } from '../../../../../../context/EditAdministratorProvider';
import { AvailableTenantInterface } from '../../../../../../shared/type/tenant.type';
import CustomChakraButton from '../../../../../CustomChakraButton/CustomChakraButton';
import AssignNewBranch from './AssignNewBranch/AssignNewBranch';
import { StickyScrollableTableContainer } from '../../../../../DataTable/StickyScrollableTableContainer';

const AssignedBranches = () => {
  const columnHelper = createColumnHelper<AvailableTenantInterface>();
  const { adminEditContext, unassignTenantFromAdministrator, fetchEditAdministratorContext } =
    useEditAdministratorContext();

  const [isLoading, setIsLoading] = useState(true);
  const [showAssignBranchPopUp, setShowAssignBranchPopUp] = useState(false);

  const columns = [
    columnHelper.accessor('name', {
      header: 'Nazwa oddziału',
      cell: (info) => (
        <p className="text-sm text-grayLight-900 font-medium underline truncate max-w-[200px]">
          {info.getValue()}
        </p>
      )
    }),
    columnHelper.display({
      id: 'actions',
      header: '',
      cell: ({ row }) => (
        <div className="flex gap-4">
          <button
            onClick={() => unassignTenantFromAdministrator(row.original.id)}
            type="button"
            className="font-semibold text-sm text-grayLight-600">
            Usuń
          </button>
        </div>
      )
    })
  ];

  useEffect(() => {
    setIsLoading(false);
  }, []);

  return (
    <section className="AssignedBranches p-spacing-xl w-full">
      <Box mb={6} className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <Text fontSize="xl" fontWeight="semibold" color="gray.900">
            Przypisane oddziały
          </Text>
        </div>
        <CustomChakraButton
          size="md"
          hierarchy="primary"
          iconPosition="left"
          iconColor="#292524"
          icon="plus"
          buttonProps={{
            onClick: () => setShowAssignBranchPopUp(true)
          }}>
          Przypisz oddział
        </CustomChakraButton>
      </Box>

      <StickyScrollableTableContainer
        columns={columns}
        data={adminEditContext?.adminUserDto.assignedTenants || []}
        isLoading={isLoading}
        enableSearch={true}
      />

      {showAssignBranchPopUp && (
        <AssignNewBranch
          isOpen={showAssignBranchPopUp}
          onClose={() => {
            fetchEditAdministratorContext();
            setShowAssignBranchPopUp(false);
          }}
        />
      )}
    </section>
  );
};

export default AssignedBranches;
